export enum SearchBoxPropertyType {
    RESIDENTIAL,
    COMMERCIAL,
}

export enum tealiumTrackingParameter {
    AJAX_RELOAD = 'userdefined',
    INITIAL = 'predefined',
}
